<template>
  <div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
      <!-- Header -->
      <div class="px-8 py-6 border-b border-gray-200 bg-primary-50">
        <h3 class="text-2xl font-bold text-gray-900">
          {{ instrument?.id ? 'Edit Instrument' : 'New Instrument' }}
        </h3>
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto px-8 py-6 space-y-6">
        <!-- Name -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">
            Name <span class="text-red-500">*</span>
          </label>
          <input
            v-model="formData.name"
            type="text"
            placeholder="e.g., Depression Screening"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-dark focus:border-transparent transition-all"
          />
        </div>

        <!-- Description -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">
            Description <span class="text-red-500">*</span>
          </label>
          <textarea
            v-model="formData.description"
            rows="4"
            placeholder="Describe what this instrument assesses..."
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-dark focus:border-transparent transition-all resize-none"
          />
        </div>

        <!-- Metadata -->
        <div class="bg-gray-50 rounded-lg p-6 border border-gray-200">
          <h4 class="font-semibold text-gray-900 mb-4">Metadata</h4>
          <div class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">Category</label>
              <input
                v-model="formData.metadata.category"
                type="text"
                placeholder="e.g., Mental Health, Social Determinants"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-dark focus:border-transparent transition-all"
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">Estimated Duration (minutes)</label>
              <input
                v-model.number="formData.metadata.estimated_duration_minutes"
                type="number"
                min="1"
                placeholder="e.g., 5"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-dark focus:border-transparent transition-all"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="px-8 py-6 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
        <button
          @click="$emit('close')"
          class="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-all font-medium"
        >
          Cancel
        </button>
        <button
          @click="save"
          :disabled="!isValid"
          class="btn-primary"
        >
          <FontAwesomeIcon :icon="['fas', 'check']" />
          Save Instrument
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'InstrumentEditor',

  components: {
    FontAwesomeIcon
  },

  props: {
    instrument: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      formData: {
        name: '',
        description: '',
        metadata: {
          category: '',
          estimated_duration_minutes: null
        }
      }
    };
  },

  computed: {
    isValid() {
      return this.formData.name?.trim() && this.formData.description?.trim();
    }
  },

  mounted() {
    if (this.instrument) {
      this.formData = {
        ...this.instrument,
        metadata: this.instrument.metadata || { category: '', estimated_duration_minutes: null }
      };
    }
  },

  methods: {
    save() {
      if (!this.isValid) return;
      this.$emit('save', this.formData);
    }
  }
};
</script>
